import { Button, Div, Input, Label } from "components";
import { Ecolors } from "constants/themes";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { AppState, AppStateStatus, StyleSheet } from "react-native";

function ItemOTPInput(p: { value: string; isFocus: boolean }) {
  const inte = useRef<any>(null);
  const [isShow, setIsShow] = useState<boolean>(false);

  useEffect(() => {
    if (p.isFocus) {
      startInte();
    } else {
      clearInte();
    }
    return () => {
      clearInte();
    };
  }, [p.isFocus]);

  const startInte = () => {
    if (inte.current) {
      clearInte();
    }
    inte.current = setInterval(() => {
      setIsShow((a) => !a);
    }, 700);
  };

  const clearInte = () => {
    if (inte.current) {
      clearInterval(inte.current);
      inte.current = null;
    }
  };
  return (
    <Div
      width={46}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      marginHorizontal={4}
      borderBottomWidth={4}
      borderBottomColor={
        p.isFocus
          ? isShow
            ? Ecolors.mainColor
            : Ecolors.spaceColor
          : Ecolors.spaceColor
      }
    >
      <Label size={30} multilanguage={false}>
        {p.value}
      </Label>
    </Div>
  );
}

const OtpComp = (
  props: {
    maxTime?: number;
    otp?: string;
    isInTime?: boolean;
    setIsInTime?: (r: boolean) => void;
    setOtp?: (r: string) => void;
  },
  ref: any,
) => {
  const DEFAULT_TIME = props.maxTime || 90;
  const [time, setTime] = useState(DEFAULT_TIME);
  const timerInterval: any = useRef(null);
  const inputRef = useRef<any>(null);
  const timeLast = useRef<any>(null);

  const appState = useRef(AppState.currentState);
  useEffect(() => {
    const handler = (next: AppStateStatus) => {
      if (next === "background") {
        timeLast.current = Date.now();
      }

      if (next === "active" && timeLast.current) {
        const diff = Math.floor((Date.now() - timeLast.current) / 1000);
        setTime((t) => Math.max(t - diff, 0));
        timeLast.current = 0;
      }
      appState.current = next;
    };

    const subscription: any = AppState.addEventListener("change", handler);

    return () => {
      subscription.remove();
      clearTimer();
    };
  }, []);

  useImperativeHandle(ref, () => ({
    start: () => {
      startTimer();
    },
    stop: () => {
      clearTimer();
    },
  }));

  useEffect(() => {
    if (time <= 1) {
      props.setIsInTime && props.setIsInTime(false);
      props.setOtp && props.setOtp("");
      clearTimer();
    }
  }, [time]);

  const startTimer = () => {
    if (timerInterval.current) {
      clearTimer();
    }
    props.setIsInTime && props.setIsInTime(true);
    setTime(DEFAULT_TIME);
    timerInterval.current = setInterval(() => {
      setTime((a) => a - 1);
    }, 1000);
  };

  const clearTimer = () => {
    if (timerInterval.current) {
      clearInterval(timerInterval.current);
      timerInterval.current = null;
    }
  };

  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <Div backgroundColor={Ecolors.whiteColor}>
      <Div
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        marginTop={15}
      >
        {props.isInTime ? (
          <>
            <Label multilanguage={false}>
              <Label
                fontWeight={"700"}
                marginTop={10}
                size={15}
                color={Ecolors.textColor}
              >
                {`otprequestmodal.contenttiming`}
              </Label>
              <Label
                multilanguage={false}
                fontWeight={"700"}
                marginTop={10}
                size={15}
                color={Ecolors.mainColor}
              >
                {` ${time}s`}
              </Label>
            </Label>
            <Div
              alignItems={"center"}
              justifyContent={"center"}
              overflow={"hidden"}
              flexDirection={"row"}
              width={"100%"}
              height={80}
              marginTop={30}
            >
              <Input
                caretHidden={true}
                textContentType={"oneTimeCode"}
                inputRef={inputRef}
                autoFocus={true}
                padding={0}
                margin={0}
                value={props.otp}
                onChangeText={props.setOtp}
                color={Ecolors.transparent}
                maxLength={6}
                keyboardType={"number-pad"}
                width={"100%"}
                textAlign={"center"}
                fontSize={20}
                style={{
                  ...StyleSheet.absoluteFillObject,
                }}
              />
              <Button
                onPress={() => focusInput()}
                width={"100%"}
                flexDirection={"row"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                {Array(6)
                  .fill(0)
                  .map((item: any, index: number) => {
                    return (
                      <ItemOTPInput
                        key={index}
                        value={props.otp?.[index] || ""}
                        isFocus={
                          index == props.otp?.length ||
                          (index == 5 && props.otp?.length == 6)
                        }
                      />
                    );
                  })}
              </Button>
            </Div>
          </>
        ) : (
          <>
            <Label size={20} color={Ecolors.textColor} fontWeight={"600"}>
              {`otprequestmodal.otptimeout`}
            </Label>
          </>
        )}
      </Div>
    </Div>
  );
};

export default React.forwardRef(OtpComp);
